<template>
  <div class="sidebar-user">
    <!-- The logout button cannot sit inside a link, so the link is the avatar and name. -->
    <RouterLink class="sidebar-user-link"
      :class="{ 'sidebar-user-link--rail': rail }"
      :to="to"
      :title="title">
      <div class="avatar">{{ initial }}<span class="online" /></div>
      <div class="sidebar-user-info">
        <div class="name">{{ displayName }}</div>
        <div class="role">Administraator</div>
      </div>
    </RouterLink>
    <!-- In rail mode the footer is only wide enough for the avatar. -->
    <button v-show="!rail"
      class="logout-btn"
      type="button"
      title="Logi välja"
      aria-label="Logi välja"
      @click="logout">
      <i class="fa-solid fa-right-from-bracket"
        aria-hidden="true" />
    </button>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth'

// The signed-in user in Shell's sidebar footer, for the admin and the shop alike.
export default {
  name: 'sidebar-user',
  props: {
    rail: { type: Boolean, default: false },
    // Where a click on the user goes: the shop from the admin, the admin from the shop.
    to: { type: String, required: true },
    title: { type: String, default: '' },
  },
  emits: ['logout'],
  computed: {
    displayName() {
      const auth = useAuthStore()
      return auth.user?.name || auth.user?.username || 'Aktuaalne'
    },
    initial() {
      return this.displayName.charAt(0).toUpperCase()
    },
  },
  methods: {
    logout() {
      useAuthStore().logout()
      this.$emit('logout')
    },
  },
}
</script>

<style lang="scss" scoped>
// Lays out avatar and name the way .sidebar-user does; in rail mode only the avatar shows, so it stops filling the row.
.sidebar-user-link {
  display: flex;
  align-items: center;
  gap: 10rem;
  flex: 1;
  min-width: 0;
  color: inherit;
  text-decoration: none;

  &--rail {
    flex: 0 0 auto;
  }
}

// gentelella's .sidebar-user has no sign-out affordance; this adds one at the
// far edge of the row.
.logout-btn {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  margin-left: auto;
  width: 28rem;
  height: 28rem;
  border: 0;
  border-radius: 8rem;
  background: transparent;
  color: inherit;
  font-size: 14rem;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.15s ease, background-color 0.15s ease;

  &:hover,
  &:focus-visible {
    opacity: 1;
    background: rgba(255, 255, 255, 0.12);
  }
}
</style>
